import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants';
import { NeutralColors } from '@/theme';

import Tabs from '../Tabs';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

/**
 * Only pages with tabs get the bottom border — the tab strip's own bottom
 * padding is dropped so the active tab's ink bar sits flush on top of it,
 * and a bottom margin keeps the page content below from touching the line.
 */
export const Header = styled.div<{ $hasTabs?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: ${props =>
    props.$hasTabs ? `1px solid ${NeutralColors[20]}` : 'none'};
  margin-bottom: ${props => (props.$hasTabs ? '16px' : '0')};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  align-self: flex-end;
  padding: 0 16px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const HeaderTabs = styled(Tabs)`
  .${CSS_PREFIX}-tabs-nav {
    margin: 0;
  }

  .${CSS_PREFIX}-tabs-nav::before {
    border-bottom: none;
  }

  .${CSS_PREFIX}-tabs-content-holder {
    display: none;
  }

  .${CSS_PREFIX}-tabs-tab {
    padding: 16px 50px;
  }

  .${CSS_PREFIX}-tabs-tab:not(.${CSS_PREFIX}-tabs-tab-active)
    .${CSS_PREFIX}-tabs-tab-btn {
    color: ${NeutralColors[60]};
  }

  .${CSS_PREFIX}-tabs-tab-active .${CSS_PREFIX}-tabs-tab-btn {
    font-weight: 600;
  }
`;
